import { css } from '@emotion/react';
import { PropsWithChildren } from 'react';

import { theme } from '../theme';

const styles = {
  container: css`
    display: flex;
    gap: ${theme.spacing.lg};
  `,
};

export function CartSection({ children, className }: PropsWithChildren<{ className?: string }>) {
  return (
    <div css={styles.container} className={className}>
      {children}
    </div>
  );
}
